import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { ManageSkillsListDialog } from '@/features/user-management/ManageSkillsListDialog'
import { type ManageSkillsListDialogViewModel } from './ManageSkillsListDialogViewModel'

export interface ManageSkillsListDialogContainerProps {
  vm: ManageSkillsListDialogViewModel
}

export const ManageSkillsListDialogContainer = observer(
  function ManageSkillsListDialogContainer({
    vm,
  }: ManageSkillsListDialogContainerProps) {
    return (
      <ManageSkillsListDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        onSearchTextChange={vm.setSearchText}
        isWorkspaceSelected={vm.isWorkspaceSelected}
        allSelected={vm.allSelected}
        onSelectAllChange={vm.selectAllSkills}
        skills={vm.filteredSkills.map((skill) => ({
          id: skill.id,
          name: skill.name,
          description: skill.description,
          tagLabels: skill.tags.map((tag) => tag.label),
          isSelected: vm.skills.has(skill.id),
          onToggle: () => vm.toggleSkill(skill),
        }))}
        scrollLoader={
          <InfiniteScrollLoaderContainer scrollProvider={vm.scroller} />
        }
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      />
    )
  },
)
